module.exports = __webpack_public_path__ + "img/HR.23aa4c3f.png";